module.exports = __webpack_public_path__ + "img/prec.a527e888.png";